import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/megapack';
import { SectionHeading } from './SectionHeading';
import { useReveal } from '../hooks/useReveal';
export function TestimonialsSection() {
  const listRef = useReveal<HTMLUListElement>();
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" aria-labelledby="testimonials-title" data-id="element-260" data-mp="1r1dwqcz2r522">
      <div className="mx-auto max-w-5xl" data-id="element-261" data-mp="1d24d13bntstc">
        <SectionHeading id="testimonials-title" title={<>
              Lo que dicen las seños que ya tienen su <span className="mark-lime" data-id="element-263" data-mp="1i2ipcxkanox6">MegaPack</span>
            </>} subtitle="Testimonios modelo para reemplazar por reales." data-id="element-262" data-mp="1d12zms768u8g" />

        <ul ref={listRef} className="reveal-group mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-264" data-mp="143j1vt8ipg2l">
          {testimonials.map((testimonial, index) => <li key={testimonial.name} style={{
          transitionDelay: `${index * 50}ms`
        }} className="reveal flex flex-col rounded-3xl border-2 border-forest-100 bg-white p-5 shadow-card" data-id="element-265" data-mp="2yexrma1j3fic" data-mpi={index}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-266" data-mp="2v0j33gxfbovk">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-267" data-mp="2q1gc30ea3j6l" />)}
              </div>

              <blockquote className="mt-3 flex-1 text-[13px] leading-relaxed text-forest-900/80" data-id="element-268" data-mp="34tgqo1h9w411">
                “{testimonial.quote}”
              </blockquote>

              <figcaption className="mt-5 flex items-center gap-3 border-t-2 border-dashed border-forest-100 pt-4" data-id="element-269" data-mp="2c3rm5e5ctluo">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-forest-800 font-display text-[11px] font-extrabold text-cream" data-id="element-270" data-mp="2756mbfu0l46r">
                  {testimonial.initials}
                </span>
                <span data-id="element-271" data-mp="2h3w5rd1k6wp4">
                  <span className="block font-display text-sm font-bold text-forest-800" data-id="element-272" data-mp="1anf1u821p9i">
                    {testimonial.name}
                  </span>
                  <span className="block text-[11px] text-forest-900/55" data-id="element-273" data-mp="3sggh4lz0pxp8">{testimonial.role}</span>
                </span>
              </figcaption>
            </li>)}
        </ul>
      </div>
    </section>;
}